import React, { useEffect, useState } from 'react'; // [UPDATE] Thêm useState
import { useCart } from '../../context/CartContext';
import styles from './CartPage.module.scss';
import { Link, useNavigate } from 'react-router-dom'; // [UPDATE] Thêm useNavigate
import { IoTrashOutline, IoArrowBack, IoBagHandleOutline, IoCheckmarkCircleOutline } from 'react-icons/io5';
import { toast } from 'react-toastify'; 
import productService from '../../services/productService'; // [UPDATE] Import service để check kho

const BACKEND_URL = 'https://huongtramcomoc.vn';
const PLACEHOLDER_IMAGE = '/images/placeholder.jpg';

const CartPage = () => {
  const { cartItems, updateQuantity, removeFromCart, getCartTotal, calculateFinalPrice } = useCart();
  const navigate = useNavigate(); // [UPDATE] Hook điều hướng
  const [isChecking, setIsChecking] = useState(false); // [UPDATE] Trạng thái loading khi check kho

  useEffect(() => {
    cartItems.forEach(item => {
        if (item.quantity <= 0) {
            removeFromCart(item.id);
        }
    });
  }, [cartItems, removeFromCart]);

  // [UPDATE] Hàm kiểm tra tồn kho thực tế trước khi thanh toán
  const handleCheckout = async () => {
    if (cartItems.length === 0) return;
    setIsChecking(true);

    try {
        let hasError = false;

        const stockChecks = await Promise.all(cartItems.map(async (item) => {
            try {
                // Gọi API lấy thông tin mới nhất từ server
                const res = await productService.getProductById(item.id);
                const serverStock = parseInt(res.data.stock_quantity || 0);
                return { 
                    id: item.id, 
                    name: item.name, 
                    currentQty: item.quantity, 
                    serverStock: serverStock 
                };
            } catch (error) {
                console.error("Lỗi check kho sản phẩm ID " + item.id, error);
                return null;
            }
        }));

        // Duyệt qua kết quả kiểm tra
        for (const check of stockChecks) {
            if (!check) continue; // Bỏ qua nếu lỗi mạng

            // Nếu số lượng khách mua > số lượng thực tế trong kho
            if (check.currentQty > check.serverStock) {
                hasError = true;
                if (check.serverStock <= 0) {
                    toast.error(`Sản phẩm "${check.name}" vừa hết hàng!`);
                    updateQuantity(check.id, 0); // Hoặc removeFromCart(check.id)
                } else {
                    toast.warning(`"${check.name}" chỉ còn ${check.serverStock} sản phẩm. Đã cập nhật lại giỏ hàng.`);
                    updateQuantity(check.id, check.serverStock); // Cập nhật về số lượng tối đa có thể mua
                }
            }
        }

        // Nếu không có lỗi gì thì mới chuyển trang
        if (!hasError) {
            navigate('/thanh-toan');
        }

    } catch (error) {
        console.error("Lỗi hệ thống:", error);
        toast.error("Có lỗi khi kiểm tra kho hàng. Vui lòng thử lại.");
    } finally {
        setIsChecking(false);
    }
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('vi-VN', { 
      style: 'currency', currency: 'VND' 
    }).format(price);
  };

  const total = getCartTotal();

  if (cartItems.length === 0) {
    return (
      <div className={styles.emptyContainer}>
        <div className={styles.emptyContent}>
            <div className={styles.emptyIcon}>
            <IoBagHandleOutline />
            </div>
            <h2>Giỏ hàng chưa có sản phẩm</h2>
            <p>Hãy chọn những món quà ý nghĩa từ Hương Trầm Cổ Mộc nhé!</p>
            <Link to="/san-pham" className={styles.shopNowBtn}>
            Tiếp tục mua sắm
            </Link>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.pageWrapper}>
      
      <div className={styles.stepperContainer}>
        <div className={styles.stepper}>
            <div className={`${styles.step} ${styles.active}`}><div className={styles.stepNum}>1</div><span>Giỏ Hàng</span></div>
            <div className={styles.connector}></div>
            <div className={styles.step}><div className={styles.stepNum}>2</div><span>Thanh Toán</span></div>
            <div className={styles.connector}></div>
            <div className={styles.step}><div className={styles.stepNum}>3</div><span>Hoàn Tất</span></div>
        </div>
      </div>

      <div className={styles.mainContainer}>
        <div className={styles.cartGrid}>
          
          <div className={styles.leftColumn}>
            <div className={styles.cartHeader}>
              <h1>Giỏ Hàng <span className={styles.itemCount}>({cartItems.length} sản phẩm)</span></h1>
            </div>

            <div className={styles.productList}>
              {cartItems.map(item => {
                const imageUrl = item.thumbnail_url 
                  ? (item.thumbnail_url.startsWith('http') ? item.thumbnail_url : `${BACKEND_URL}${item.thumbnail_url}`)
                  : PLACEHOLDER_IMAGE;
                
                const finalPrice = calculateFinalPrice(item);
                const originalPrice = parseFloat(item.price || 0);
                const hasDiscount = (originalPrice - finalPrice) > 1000;
                const currentStock = (item.stock_quantity !== undefined && item.stock_quantity !== null) 
                                     ? parseInt(item.stock_quantity) 
                                     : 999;

                const handleIncrease = () => {
                    if (item.quantity < currentStock) {
                        updateQuantity(item.id, item.quantity + 1);
                    } else {
                        toast.warning(`Kho chỉ còn ${currentStock} sản phẩm!`);
                    }
                };

                // Kiểm tra max
                const isMaxReached = item.quantity >= currentStock;

                return (
                  <div key={item.id} className={styles.cartItem}>
                    
                    <div className={styles.imgWrapper}>
                      <img src={imageUrl} alt={item.name} />
                    </div>
                    
                    <div className={styles.itemDetails}>
                        <div className={styles.infoTop}>
                            <Link to={`/san-pham/${item.id}`} className={styles.itemName}>
                                {item.name}
                            </Link>
                            <span className={styles.variant}>
                                {currentStock < 999 ? `Còn lại: ${currentStock}` : 'Sẵn hàng'}
                            </span>
                            
                            <div className={styles.priceGroup}>
                                <span className={styles.finalPrice}>{formatPrice(finalPrice)}</span>
                                {hasDiscount && (
                                    <span className={styles.originalPrice}>{formatPrice(originalPrice)}</span>
                                )}
                            </div>
                        </div>

                        <div className={styles.actionsBottom}>
                            <div className={styles.qtyBox}>
                                <button onClick={() => updateQuantity(item.id, item.quantity - 1)} disabled={item.quantity <= 1}>-</button>
                                <input type="text" value={item.quantity} readOnly />
                                <button 
                                    onClick={handleIncrease} 
                                    disabled={isMaxReached}
                                    style={{ opacity: isMaxReached ? 0.3 : 1, cursor: isMaxReached ? 'not-allowed' : 'pointer' }}
                                >
                                    +
                                </button>
                            </div>

                            <div className={styles.subTotal}>
                                {formatPrice(finalPrice * item.quantity)}
                            </div>

                            <button onClick={() => removeFromCart(item.id)} className={styles.btnRemove} title="Xóa">
                                <IoTrashOutline />
                            </button>
                        </div>
                    </div>
                  </div>
                );
              })} 
            </div>
            
            <Link to="/san-pham" className={styles.backLink}>
              <IoArrowBack /> Tiếp tục xem sản phẩm
            </Link>
          </div>

          <div className={styles.rightColumn}>
            <div className={styles.summaryBox}>
              <h3>Tóm Tắt Đơn Hàng</h3>
              
              <div className={styles.row}>
                <span>Tạm tính</span>
                <span>{formatPrice(total)}</span>
              </div>
              <div className={styles.row}>
                <span>Phí vận chuyển</span>
                <span className={styles.greenText}>Miễn phí</span>
              </div>
              
              <div className={styles.divider}></div>
              
              <div className={`${styles.row} ${styles.totalRow}`}>
                <span>Tổng cộng</span>
                <span className={styles.totalValue}>{formatPrice(total)}</span>
              </div>
              
              <p className={styles.vatText}>(Đã bao gồm VAT nếu có)</p>

              {/* [UPDATE] Thay Link bằng Button để xử lý check kho */}
              <button 
                onClick={handleCheckout} 
                className={styles.btnCheckout}
                disabled={isChecking}
                style={{ opacity: isChecking ? 0.7 : 1, cursor: isChecking ? 'wait' : 'pointer' }}
              >
                {isChecking ? 'ĐANG KIỂM TRA...' : 'TIẾN HÀNH THANH TOÁN'}
              </button>
              
              <div className={styles.secureText}>
                <IoCheckmarkCircleOutline /> Bảo mật thanh toán 100%
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CartPage;